import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable, Inject } from '@angular/core';
import { API_SERVER_TOKEN } from '../api-server-token';
import { GtinPlu, GtinPluId, NewGtinPlu, ProductId } from '@portal-front-end/models';
import { Update } from '@ngrx/entity';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })

export class GtinPluApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly GTINPLU_URL = `${this.apiServer}/gtin-plu`;

    getPluById(pluId: GtinPluId): Observable<GtinPlu> {
        return this.http.get<GtinPlu>(`${this.GTINPLU_URL}${pluId}`);
    }

    getPlus(): Observable<GtinPlu[]> {
        return this.http.get<GtinPlu[]>(this.GTINPLU_URL);
    }

    getPlusForProduct(productId: string): Observable<GtinPlu[]> {
        return this.http.get<GtinPlu[]>(`${this.GTINPLU_URL}/search`,
            { 'params': { 'productId': productId } }
        );
    }

    updatePlu(payload: Update<GtinPlu>): Observable<GtinPlu> {
        return this.http.put<GtinPlu>(`${this.GTINPLU_URL}/${payload.changes.gtinPluId}`, payload.changes);
    }

    insertPlus(object: NewGtinPlu): Observable<GtinPlu> {
        return this.http.post<GtinPlu>(this.GTINPLU_URL, object);
    }

    getPluByProductId(productId: ProductId): Observable<GtinPlu[]> {
        return this.http.get<GtinPlu[]>(`${this.GTINPLU_URL}/product/${productId}`);
    }

    deleteGtinPlu(id: string | number): Observable<string | number>{
        return this.http.delete<string | number>(`${this.GTINPLU_URL}/${id}`)
            .pipe(map(() => id));
    }
}
